import dynamic from 'next/dynamic';

import { HouseKeepingProps } from './HouseKeeping.types';

export const HouseKeeping = dynamic<HouseKeepingProps>(() =>
  import('./HouseKeeping').then(module => module.HouseKeeping)
);
